<template>
    <v-dialog v-model="dialog" max-width="290" persistent>
        <v-card>
            <v-card-title class="headline">
                Roles
                <v-spacer></v-spacer>
                <v-icon color="error" @click="close()">clear</v-icon>
            </v-card-title>
    
            <v-card-text class="px-0">
                <v-layout wrap>
                    <v-flex xs12 class="px-3" v-for="role in roles" :key="`role-${role.id}`">
                        <v-btn block outline large color="indigo" @click="doClockIn(role.id)">
                            {{role.name}}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "role",
  props: {
    roles: Array,
    enable: Boolean,
    action: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("update:enable", false);
    },
    doClockIn(roleId) {
      this.close();
      this.action(roleId);
    }
  },
  watch: {
    enable(e) {
      if (e) {
        this.dialog = true;
      }
    }
  }
};
</script>
